module.exports = __webpack_public_path__ + "static/media/logo-vigdis-white-fr.852afad2.png";